import api from '../connector'

export const usersTokenObtain = async (data: {
  login: string
  password: string
}) => await api.post<any>('/users/token/obtain', data)

export const getUserInfo = async () =>
  await api.get<{
    id: string
    subject_id: string
    first_name: string
    last_name: string
    email: string
    kind: string
    login: string
    login_kind: string
    has_filled_sociodemographic_data: boolean
  }>('/users/userinfo')
